import '../../modules/inputValidate';

document.querySelector('[name="targeted_delivery"]')?.addEventListener('change', function () {
    document.querySelector('[name="targeted_delivery_radius"]').readOnly = !this.checked
    document.querySelector('[name="targeted_delivery_price"]').readOnly = !this.checked
    document.querySelector('[name="delivery_price_per_item"]').readOnly = !this.checked
    document.querySelector('[name="delivery_price_max"]').readOnly = !this.checked
    document.querySelector('[name="message_for_client"]').readOnly = !this.checked
})

document.querySelector('[name="pickup"]')?.addEventListener('change', function () {
    let inputs = document.querySelectorAll('[name^="pickup_points"]');
    for (let i = 0; i < inputs.length; i++) {
        let input = inputs[i];
        if (input.tagName === 'INPUT' && input.type !== 'hidden' || input.tagName === 'TEXTAREA' && input.type !== 'hidden') {
            input.readOnly = input.hasAttribute('data-readonly') || !this.checked;
        }
    }
    let addBtn = document.getElementById('js-pickup-btn-add');
    if(addBtn){
        if(this.checked){
            addBtn.classList.remove('d-none')
        }else{
            addBtn.classList.add('d-none')
        }
    }
})
if (window.pickupPointsView) {
    let pointClass = 'js-pickup-point'
    let points = document.getElementById('js-pickup-points');
    let addBtn = document.getElementById('js-pickup-btn-add');

    addBtn.addEventListener('click', function () {
        let html = window.pickupPointsView;

        let id = Math.round(Math.random() * 10e6)
        html = html.replaceAll('pickup_points[new]', 'pickup_points[new_'+id+']');
        html = html.replaceAll('id="', 'id="pickup-'+id+'-');
        points.insertAdjacentHTML('beforeend', html);
        init();
    });
    init();

    function init() {
        $(".js-pickup-point-address").suggestions({
            token: "7adee2df98d5d1b6a1479bded0c82872415afe00",
            type: "ADDRESS",
            /* Вызывается, когда пользователь выбирает одну из подсказок */
            onSelect: function (suggestion) {
                let pointElement = this;
                for (let i = 0; i < 20; i++) {
                    if (pointElement.tagName === 'BODY' || pointElement.classList.contains(pointClass)) {
                        break;
                    }
                    pointElement = pointElement.parentNode;
                }
                if (pointElement.tagName !== 'BODY') {
                    let latInput = pointElement.querySelector('.js-pickup-point-lat');
                    let lonInput = pointElement.querySelector('.js-pickup-point-lon');

                    if (latInput) {
                        latInput.value = suggestion.data.geo_lat;
                    }
                    if (lonInput) {
                        lonInput.value = suggestion.data.geo_lon;
                    }
                }
            }
        });
    }
}
